import forge from 'node-forge';
import { generateCSR } from "../../../parskit/services/parskey-service";

export async function generate_pair_keys(setPublicKeyPem, setPrivateKeyPem) {
    try {


        // if (window.crypto && window.crypto.subtle && window.crypto.subtle.generateKey) {
        const { publicKey, privateKey } = await window.crypto.subtle.generateKey(
            {
                name: "RSA-OAEP",
                modulusLength: 2048,
                publicExponent: new Uint8Array([1, 0, 1]),
                hash: "SHA-256",
            },
            true,
            ["encrypt", "decrypt"]
        );

        // Convert keys to PEM format
        // const publicKeyPEM = `-----BEGIN PUBLIC KEY-----\n${btoa(String.fromCharCode(...new Uint8Array(await crypto.subtle.exportKey("spki", publicKey))))}\n-----END PUBLIC KEY-----`;
        // const privateKeyPEM = `-----BEGIN PRIVATE KEY-----\n${btoa(String.fromCharCode(...new Uint8Array(await crypto.subtle.exportKey("pkcs8", privateKey))))}\n-----END PRIVATE KEY-----`;
        // console.log("privateKeyPEM : " + privateKeyPEM)
        const publicKeyArrayBuffer = await crypto.subtle.exportKey("spki", publicKey);
        const publicKeyBase64 = btoa(String.fromCharCode(...new Uint8Array(publicKeyArrayBuffer)));
        const formattedPublicKey = formatKey(publicKeyBase64, "PUBLIC KEY");

        // Export and format the private key
        const privateKeyArrayBuffer = await crypto.subtle.exportKey("pkcs8", privateKey);
        const privateKeyBase64 = btoa(String.fromCharCode(...new Uint8Array(privateKeyArrayBuffer)));
        const formattedPrivateKey = formatKey(privateKeyBase64, "PRIVATE KEY");

        setPublicKeyPem(formattedPublicKey)
        setPrivateKeyPem(formattedPrivateKey)


    } catch (error) {
        console.error("Error generating key pair:", error);
    }
}

function formatKey(keyBase64, keyType) {
    const keyHeader = `-----BEGIN ${keyType}-----\n`;
    const keyFooter = `\n-----END ${keyType}-----`;

    // Split the base64 string into chunks of 64 characters
    const chunkSize = 64;
    const keyBody = keyBase64.match(new RegExp(`.{1,${chunkSize}}`, "g")).join("\n");

    return keyHeader + keyBody + keyFooter;
}

export const privateKeyToPublicKey = (privateKey) => {

    const pkey = forge.pki.privateKeyFromPem(privateKey)
    const pubkey = forge.pki.setRsaPublicKey(pkey.n, pkey.e)

    return forge.pki.publicKeyToPem(pubkey)

};

export const generate_csr_without_sign = (keyId, publicKeyPem, completeInfo, completeInfoApi) => {

    const csrSubjects = [completeInfo.countryName, completeInfo.commonName ?
        completeInfo.commonName :
        completeInfoApi.latinFirstName + ' ' + completeInfoApi.latinLastName + ' [Sign]', "", "", completeInfo.stateOrProvinceName ?
        completeInfo.stateOrProvinceName :
        completeInfoApi.province, completeInfo.stateOrProvinceName ?
        completeInfo.stateOrProvinceName :
        completeInfoApi.province, "", completeInfo.givenName ?
        completeInfo.givenName :
        completeInfoApi.latinFirstName, completeInfo.serialNumber ?
        completeInfo.serialNumber :
        completeInfoApi.nationalId, completeInfo.surname ?
        completeInfo.surname :
        completeInfoApi.latinLastName];
    generateCSR(keyId, csrSubjects).then((response) => {
        return response.data.pk_opX509CSR;
    });
    return "";
    /* initializeSign(1,0).then(() => {
         signWithoutGUI(forge.asn1.toDer(csr.certificationRequestInfo).toHex().toUpperCase(),4,null,"1234",0,keyId).then((response) => {
             console.log(response)
         })
         // signWithoutGUIRequest(forge.asn1.toDer(csr.certificationRequestInfo).toHex().toUpperCase(),4,null,keyId)
         console.log(forge.asn1.toDer(csr.certificationRequestInfo).toHex())
         let csrPem = forge.pki.certificationRequestToPem(csr);
         console.log(csrPem);

         return csr;
     });*/


}

export const generate_csr = (publicKeyPem, privateKeyPem, completeInfo, completeInfoApi) => {

    const privateKey = forge.pki.privateKeyFromPem(privateKeyPem)
    const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

    const csr = forge.pki.createCertificationRequest();
    csr.publicKey = publicKey;

    csr.setSubject([
        {
            name: 'commonName', value: completeInfo.commonName ?
                completeInfo.commonName :
                completeInfoApi.latinFirstName + ' ' + completeInfoApi.latinLastName + ' [Sign]'
        },

        { name: "organizationName", value: completeInfo.organizationName },

        {
            name: 'localityName', value: completeInfo.stateOrProvinceName ?
                completeInfo.stateOrProvinceName :
                completeInfoApi.province
            , valueTagClass: 12
        },

        {
            name: "stateOrProvinceName", value: completeInfo.stateOrProvinceName ?
                completeInfo.stateOrProvinceName :
                completeInfoApi.province
            , valueTagClass: 12
        },
        { name: 'countryName', value: completeInfo.countryName },

        {
            name: "serialNumber", value: completeInfo.serialNumber ?
                completeInfo.serialNumber :
                completeInfoApi.nationalId
        },
        {
            name: "givenName", value: completeInfo.givenName ?
                completeInfo.givenName :
                completeInfoApi.latinFirstName
        },
        {
            name: "surname", value: completeInfo.surname ?
                completeInfo.surname :
                completeInfoApi.latinLastName
        }
    ]);


    const validity = {
        notBefore: new Date(new Date().setFullYear(new Date().getFullYear() - 2)), // current date and time
        notAfter: new Date(new Date().setFullYear(new Date().getFullYear() - 1)), // valid for 1 year
    };
    csr.validity = validity;


    // Sign the CSR with the private key
    csr.sign(privateKey);

    // Convert the CSR to PEM format
    let csrPem = forge.pki.certificationRequestToPem(csr);
    csrPem = csrPem.replace("-----BEGIN CERTIFICATE REQUEST-----", "")
    csrPem = csrPem.replace("-----END CERTIFICATE REQUEST-----", "")
    csrPem = csrPem.replaceAll("\n", "")
    csrPem = csrPem.replaceAll("\r", "")

    return csrPem;

}

export const generate_csr_without_sign_company = (keyId, publicKeyPem, companyInfo) => {

    const csrSubjects = [
        companyInfo?.companyNationalId,
        companyInfo?.latinCompanyName,
        companyInfo?.companyType,
        companyInfo?.province,
        companyInfo?.city,
        companyInfo?.country,
        companyInfo?.latinCompanyName + ' [Stamp]'
    ];
    generateCSR(keyId, csrSubjects).then((response) => {
        return response.data.pk_opX509CSR;
    });

    return "";
    /* initializeSign(1,0).then(() => {
         signWithoutGUI(forge.asn1.toDer(csr.certificationRequestInfo).toHex().toUpperCase(),4,null,"1234",0,keyId).then((response) => {
             console.log(response)
         })
         // signWithoutGUIRequest(forge.asn1.toDer(csr.certificationRequestInfo).toHex().toUpperCase(),4,null,keyId)
         console.log(forge.asn1.toDer(csr.certificationRequestInfo).toHex())
         let csrPem = forge.pki.certificationRequestToPem(csr);
         console.log(csrPem);

         return csr;
     });*/


}

export const generate_csr_company = (publicKeyPem, privateKeyPem, companyInfo) => {

    const privateKey = forge.pki.privateKeyFromPem(privateKeyPem)
    const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

    const csr = forge.pki.createCertificationRequest();

    csr.publicKey = publicKey;

    csr.setSubject([
        {
            name: "commonName", value: companyInfo?.latinCompanyName + ' [Stamp]'
        },
        {
            name: 'serialNumber', value: companyInfo?.companyNationalId
        },
        {
            name: 'countryName', value: companyInfo?.country
        },
        {
            name: "localityName", value: companyInfo?.province, valueTagClass: 12
        },
        {
            name: "stateOrProvinceName", value: companyInfo?.city, valueTagClass: 12
        },
        {
            name: 'organizationName', value: companyInfo?.companyType
        },
        {
            name: "organizationalUnitName", value: companyInfo?.latinCompanyName
        },

    ]);


    const validity = {
        notBefore: new Date(new Date().setFullYear(new Date().getFullYear() - 2)), // current date and time
        notAfter: new Date(new Date().setFullYear(new Date().getFullYear() - 1)), // valid for 1 year
    };
    csr.validity = validity;


    // Sign the CSR with the private key
    csr.sign(privateKey);

    // Convert the CSR to PEM format
    let csrPem = forge.pki.certificationRequestToPem(csr);
    csrPem = csrPem.replace("-----BEGIN CERTIFICATE REQUEST-----", "")
    csrPem = csrPem.replace("-----END CERTIFICATE REQUEST-----", "")
    csrPem = csrPem.replaceAll("\n", "")
    csrPem = csrPem.replaceAll("\r", "")

    


    return csrPem;

}